<template>

<b-row class="w-100 d-flex justify-content-center align-items-center" style="padding-top: 10px; height:80%; margin: 0;">
        <loading :active="loading"
                :is-full-page="false"/>
        <div v-if="thereIsNoData" class="d-flex align-items-center justify-content-center" style="height: 80%; width: 100%;">
            <span style="font-size: 1.125rem; font-weight: bold;">No Data</span>
        </div>
        <apexchart v-if="series && !thereIsNoData" id="chart" style="flex:1;"
        width="100%" height="90%" ref="apexchart" 
        :options="chartOptions" 
            :series="series" />
    </b-row>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import {generateLabelDateArray, getProjectPeriodByHistory, getHistoryGroupByStatus} from '@/components/chatter/util/graphUtils';
export default {
    name: 'CompletionPeriodGraph',
    props: [
        'dashboardData',
        'filters',
        'isFlexible'
    ],
    components: {
        apexchart: VueApexCharts
    },
    mounted() {
        // this.setSeries();
        // this.setLabels();
        this.historyData = getHistoryGroupByStatus(this.dashboardData.history);
        
        if(this.historyData.length <= 0) {
            this.thereIsNoData = true;
        } else {
            this.startDate = this.dashboardData.projectInfo.startDate;
            this.endDate = this.dashboardData.projectInfo.endDate;

            // 시작, 종료 날짜 둘중 하나라도 비어있으면 히스토리에서 시작, 종료 가져옴
            if(this.startDate == '' || this.endDate == '') {
                const [historyStart, historyEnd] = getProjectPeriodByHistory(this.historyData);

                this.startDate = historyStart;
                this.endDate = historyEnd;
            }
            this.reloadGraph();
        }
    },

    watch: {
        filters: {
            deep: true,
            immediate: false,

            handler() {
                console.log("modify filter reload");
                
                this.series = [];
                this.reloadGraph();
            }
        },
    },
    data() {
        return {
            thereIsNoData : false,
            loading: false,
            labelArray: '',
            startDate: '',
            endDate: '',
            historyData: '',
            columnNames: [],
            series: [],
            dateRange : [],
            chartOptions: {
                chart: {
                    type: 'bar',
                    toolbar: {
                        show: this.isFlexible,
                        offsetX: 0,
                        offsetY: 0,
                        tools: {
                            download: true,
                            selection: true,
                            zoom: true,
                            zoomin: true,
                            zoomout: true,
                            pan: true,
                            reset: true | '<img src="/static/icons/reset.png" width="20">',
                            customIcons: []
                        },
                        export: {
                            csv: {
                                filename: undefined,
                                columnDelimiter: ',',
                                headerCategory: 'category',
                                headerValue: 'value',
                                dateFormatter(timestamp) {
                                    return new Date(timestamp).toDateString()
                                }
                            },
                            svg: {
                                filename: undefined,
                            },
                            png: {
                                filename: undefined,
                            }
                        }
                    },
                },
                series: [],
                colors: ['#142459', '#176BA0', '#19AADE', '#1AC9E6', '#1BD4D4' ],
                plotOptions: {
                    bar: {
                    columnWidth: "80%",
                    
                    horizontal: false,
                    }
                },
                dataLabels: { enabled: false },
                grid: {
                    xaxis: {
                        lines: {
                            show: false
                        }
                    },
                    yaxis: {
                        lines: {
                            show: false
                        }
                    }
                },
                xaxis: {
                    categories: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15+"],
                    labels: { 
                        show : this.isFlexible,
                    },
                    title: {
                        text: 'Days', // X축 레이블
                        style: {
                            fontSize: '14px',
                            fontWeight: 'light',
                        }
                    },
                },
                yaxis: {
                    labels: {
                        show: this.isFlexible
                    },
                    axisBorder: {
                        show: this.isFlexible,
                    }
                },
                legend: {
                    show: true,
                    showForSingleSeries: true,
                    position:'top',
                    horizontalAlign: "left",
                    offsetX: 0,
                    offsetY: this.isFlexible ? 7 : 3,
                    fontSize: this.isFlexible ? '14px' : '12px'
                },
                tooltip: {
                    onDatasetHover: {
                    highlightDataSeries: true,
                    },
                    x: { formatter: x => { return 'Days ' + x } }
                }
            },
            tableData: [],
        }
    },
    methods: {

        countData(dataArray) {

            let countArray = new Array(16).fill(0);
                dataArray.forEach(data=> {
                    // label이 15+ 면

                    // 종료된 이슈에 대해
                    if(data.status == 'DONE' && data.maxUpdatedDate != '') {
                        // 최초 생성날짜 - 완료 날짜 구하기
                        let diffDate = this.getDiffDate(data.date, data.maxUpdatedDate);
                        
                        if(diffDate > 14) {
                            countArray[countArray.length - 1]++;
                        } else {
                            countArray[Math.floor(diffDate)]++;
                        }
                        
                    }
                });

            let series = [{
                    name: 'MeMO 개수',
                    data: Array.from({length: countArray.length},
                        (_, i)=>({
                            x: this.chartOptions.xaxis.categories[i],
                            y: countArray[i],
                            ... (() => { 
                                if(i == countArray.length - 1) {
                                    return {fillColor: '#FF6767', strokeColor: '#142459'}
                                } else if (i > 3) {
                                    return {fillColor: '#176BA0', strokeColor: '#176BA0 '}
                                } else if (i > 4) {
                                    return {fillColor: '#19AADE', strokeColor: '#19AADE '}
                                } else if (i > 5){
                                    return {fillColor: '#1AC9E6', strokeColor: '#1AC9E6 '}
                                } else {
                                    return {fillColor: '#1BD4D4', strokeColor: '#1BD4D4 '}
                                }
                            })()
                        }))
                }];
            
            this.chartOptions.xaxis.max = countArray.length - 1;
            this.series = series;
            // 차트를 업데이트
            if (this.$refs.apexchart) {
                this.$refs.apexchart.updateOptions(this.chartOptions);
                // this.$refs.apexchart.forceUpdate();
            }
        
            return series;
        },

        visualizeGraph() {
            let dataArray = this.historyData;

            let from = this.startDate;
            let to = this.endDate;

            if(this.isFlexible) {
                let L1 = this.filters.L1;
                let L2 = this.filters.L2;
                let L3 = this.filters.L3;
                let JOB = this.filters.JOB;
                let PRIORITY = this.filters.PRIORITY;
                let TYPE = this.filters.TYPE;
                let BUSINESS_CATEGORY = this.filters.BUSINESS_CATEGORY;

                // None 값을 ""로 변경
                L1 = L1.map(value => value === "None" ? "" : value);
                L2 = L2.map(value => value === "None" ? "" : value);
                L3 = L3.map(value => value === "None" ? "" : value);
                JOB = JOB.map(value => value === "None" ? "" : value);
                PRIORITY = PRIORITY.map(value => value === "None" ? "" : value);
                TYPE = TYPE.map(value => value === "None" ? "" : value);
                BUSINESS_CATEGORY = BUSINESS_CATEGORY.map(value => value === "None" ? "" : value);

                // 필터에 from, to가 입력되었다면 초기화
                if(this.filters.from != '') {
                    from = this.filters.from;
                }

                if(this.filters.to != '') {
                    to = this.filters.to;
                }

                dataArray = dataArray.filter(item => {

                    let fromDateValid = false;
                    let toDateValid = false;


                    if(item.maxUpdatedDate != '') {
                        fromDateValid = new Date(item.maxUpdatedDate) >= new Date(from);
                        toDateValid = new Date(item.maxUpdatedDate) <= new Date(to);
                    }

                    return (
                        L1.includes(item.l1) &&
                        L2.includes(item.l2) &&
                        L3.includes(item.l3) &&
                        JOB.includes(item.job) &&
                        PRIORITY.includes(item.priority) &&
                        TYPE.includes(item.type) &&
                        BUSINESS_CATEGORY.includes(item.businessCategory) &&
                        fromDateValid &&
                        toDateValid
                    );
                });
            }

            let series = this.countData(dataArray);
        },
        
        reloadGraph() {
            try {
                this.loading = true;
                this.visualizeGraph();
            } catch(e) {
                this.loading = false;
                this.thereIsNoData = true;
                console.log(e);
            } finally {
                this.loading = false;
            }
        },

        setLabels() {
            this.chartOptions.xaxis.categories = this.label;

            // 차트를 업데이트
            if (this.$refs.apexchart) {
                this.$refs.apexchart.updateOptions({
                    xaxis: {
                        categories: this.label,
                    },
                });
            }
        },
        setTable() {
            this.tableData = this.data.table;

        },
        getDiffDate(start, end) {
            const creationDate = new Date(start);
            // 이슈 실제 종료 날짜
            const actualDate = new Date(end);
            
            // 종료 날짜 - 생성 날짜 (MSec 단위로 반환)
            const diffMSec = actualDate.getTime() - creationDate.getTime();

            // MSec을 Day로 변환
            let diffDate = diffMSec / (24*60*60*1000);

            return diffDate;
        }
    },
}
</script>
